import React from "react";

const Automation = (props: any) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 23 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.96182 13C1.06429 13 0.366211 12.3 0.366211 11.4C0.366211 10.5 1.06429 9.79999 1.96182 9.79999C2.36072 9.79999 2.6599 9.90001 2.95908 10.2C3.0588 10.3 3.0588 10.5 2.95908 10.6C2.85935 10.7 2.65991 10.7 2.56018 10.6C1.8621 10 0.964569 10.6 0.964569 11.3C0.964569 11.8 1.36347 12.3 1.96182 12.3C2.46045 12.3 2.95908 11.9 2.95908 11.3C2.95908 11.1 3.05882 11 3.25827 11C3.45772 11 3.55744 11.1 3.55744 11.3C3.55744 12.3 2.85935 13 1.96182 13Z"
        fill="black"
      />
      <path
        d="M8.34436 6.70001C7.44683 6.70001 6.74878 6.00001 6.74878 5.10001C6.74878 4.20001 7.44683 3.5 8.34436 3.5C9.24189 3.5 9.93997 4.20001 9.93997 5.10001C9.93997 6.00001 9.14216 6.70001 8.34436 6.70001ZM8.34436 4.10001C7.84573 4.10001 7.34711 4.50001 7.34711 5.10001C7.34711 5.60001 7.74601 6.10001 8.34436 6.10001C8.84299 6.10001 9.34161 5.70001 9.34161 5.10001C9.24189 4.60001 8.84299 4.10001 8.34436 4.10001Z"
        fill="black"
      />
      <path
        d="M13.9289 10.7C13.0313 10.7 12.3333 10 12.3333 9.10001C12.3333 8.20001 13.0313 7.5 13.9289 7.5C14.8264 7.5 15.5245 8.20001 15.5245 9.10001C15.5245 10 14.7267 10.7 13.9289 10.7ZM13.9289 8.10001C13.4302 8.10001 12.9316 8.50001 12.9316 9.10001C12.9316 9.60001 13.3305 10.1 13.9289 10.1C14.4275 10.1 14.9261 9.70001 14.9261 9.10001C14.8264 8.50001 14.4275 8.10001 13.9289 8.10001Z"
        fill="black"
      />
      <path
        d="M20.5109 3.70001C19.6134 3.70001 18.9153 3.00001 18.9153 2.10001C18.9153 1.20001 19.6134 0.5 20.5109 0.5C21.4084 0.5 22.1065 1.20001 22.1065 2.10001C22.1065 2.90001 21.4084 3.70001 20.5109 3.70001ZM20.5109 1.10001C20.0123 1.10001 19.5136 1.50001 19.5136 2.10001C19.5136 2.60001 19.9125 3.10001 20.5109 3.10001C21.0095 3.10001 21.5081 2.70001 21.5081 2.10001C21.5081 1.50001 21.1092 1.10001 20.5109 1.10001Z"
        fill="black"
      />
      <path
        d="M2.75985 10.6C2.66013 10.6 2.56039 10.6 2.56039 10.5C2.46066 10.4 2.46066 10.2 2.56039 10.1L7.04803 5.99999C7.14776 5.89999 7.3472 5.89999 7.44693 5.99999C7.54665 6.09999 7.54665 6.29998 7.44693 6.39998L2.95929 10.5C2.95929 10.6 2.85958 10.6 2.75985 10.6Z"
        fill="black"
      />
      <path
        d="M18.7159 4.39995C18.6162 4.39995 18.5164 4.39995 18.5164 4.29995C18.4167 4.19995 18.4167 3.99995 18.5164 3.89995L19.6134 2.89995C19.7132 2.79995 19.9126 2.79995 20.0123 2.89995C20.1121 2.99995 20.1121 3.19995 20.0123 3.29995L19.0151 4.29995C18.9153 4.39995 18.8156 4.39995 18.7159 4.39995Z"
        fill="black"
      />
      <path
        d="M14.627 8.20003C14.5273 8.20003 14.4276 8.20002 14.4276 8.10002C14.3279 8.00002 14.3279 7.80003 14.4276 7.70003L17.3196 5.10002C17.4193 5.00002 17.6188 5.00002 17.7185 5.10002C17.8183 5.20002 17.8183 5.40002 17.7185 5.50002L14.8265 8.10002C14.8265 8.10002 14.7268 8.20003 14.627 8.20003Z"
        fill="black"
      />
      <path
        d="M12.8321 8.7C12.7324 8.7 12.7324 8.69999 12.6326 8.59999L9.14226 6.2C9.04253 6.1 8.9428 5.89997 9.04253 5.79997C9.14225 5.69997 9.3417 5.6 9.44142 5.7L12.9318 8.09999C13.0315 8.19999 13.1313 8.39998 13.0315 8.49998C13.0315 8.59998 12.9318 8.7 12.8321 8.7Z"
        fill="black"
      />
      <path
        d="M17.2202 6.40002C16.7215 6.40002 16.2229 6.00002 16.2229 5.40002C16.2229 4.90002 16.6218 4.40002 17.2202 4.40002C17.7188 4.40002 18.2174 4.80002 18.2174 5.40002C18.2174 5.90002 17.8185 6.40002 17.2202 6.40002Z"
        fill="black"
      />
    </svg>
  );
};

export default Automation;
